import * as Yup from "yup";

export const enquirySchema = Yup.object().shape({
  firstName: Yup.string().required("first name is required"),
  lastName: Yup.string().optional().required("last name is required"),
  fullName: Yup.string().optional(),
  businessName: Yup.string().optional(),
  //   country: Yup.string().required('Country is required'),
  mobileNumber: Yup.string()
    .required("Mobile Number is required")
    .matches(/^\d{10}$/, "Mobile Number must be 10 digits"),
  //   alternativeNumber: Yup.string().optional(),
  whatsappNumber: Yup.string().optional(),
  address1: Yup.string().optional(),
  address2: Yup.string().optional(),
  //   city: Yup.string().required('City is required'),
  //   state: Yup.string().required('State is required'),
  email: Yup.string().email("Enter a valid email").optional(),
  origin: Yup.string().optional(),
  //   interestedProduct: Yup.array().of(Yup.string().required('Product interest is required')).required('At least one product is required'),
  // interestedProduct: Yup.array().of(Yup.string().optional()),
  //   customerMessage: Yup.string().optional(),
  notes: Yup.string().optional(),
  plannedArea: Yup.string().optional(),
  gst_number: Yup.string().optional(""),
});

export const enquirySchema2 = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  fullName: Yup.string().required("full name is required"),
  businessName: Yup.string().optional(),
  //   country: Yup.string().required('Country is required'),
  mobileNumber: Yup.string()
    .required("Mobile Number is required")
    .matches(/^\d{10}$/, "Mobile Number must be 10 digits"),
  //   alternativeNumber: Yup.string().optional(),
  whatsappNumber: Yup.string().optional(),
  address1: Yup.string().optional(),
  address2: Yup.string().optional(),
  //   city: Yup.string().required('City is required'),
  //   state: Yup.string().required('State is required'),
  email: Yup.string().email("Enter a valid email").optional(),
  origin: Yup.string().optional(),
  //   interestedProduct: Yup.array().of(Yup.string().required('Product interest is required')).required('At least one product is required'),
  // interestedProduct: Yup.array().of(Yup.string().optional()),
  //   customerMessage: Yup.string().optional(),
  notes: Yup.string().optional(),
  plannedArea: Yup.string().optional(),
  gst_number: Yup.string().optional(""),
  enquiryRelated: Yup.string().optional(),
  interestedIn: Yup.array().of(Yup.string()).optional(),
  preferredLanguage: Yup.string().optional(),
});
